import { SBack, STitle } from 'shj-components'

import styles from './index.module.less'
import classNames from 'classnames'
import UserInfo from '@/pages/clueManage/clueDetail/components/UserInfo/UserInfo.tsx'
import TaskNode from '@/pages/clueManage/clueDetail/components/TaskNode/TaskNode.tsx'
import FollowUpRecords from '@/pages/clueManage/clueDetail/components/FollowUp/FollowUpRecord.tsx'
import NodeSteps from '@/pages/clueManage/clueDetail/components/TaskNode/NodeSteps.tsx'
import { useEffect } from 'react'
import { useSetState } from 'ahooks'
import { getClueDetail } from '@/services/saleOpServices.ts'
import ClueDetailContext from '@/pages/clueManage/clueDetail/clueDetailContext.ts'
import { Spin } from 'antd'
import { trackPlanBaseInfo } from '@/services/customerServices.ts'
import BizTypeInfo from '@/pages/clueManage/clueDetail/components/UserInfo/BizTypeInfo.tsx'
import {getTrackDetailByClueId} from "@/services/callCenter";
import {useNavigate, useLocation} from "react-router-dom";

const ClueDetailNewPage = props => {
  const { id, saleClueId,
    viewPhoneKey = 'clueViewPhone',
    editPhoneKey = 'clueEditPhone',
    editKey= 'clueInfoEdit',
    editCustomerChannelKey = 'customerChannelModificationPermissions',
    templateNodeId,
    isWorkBench = false } = props
  const navigate = useNavigate()
  const location = useLocation()
  const [detailState, setDetailState] = useSetState<any>({
    loading: false,
    isReload: false,
    isReloadTrack: false,
    isReloadNode: false,
    isReloadRecord: false,
    isReloadTrackTab: false,
    trackDetail: {},
    templateStepId: '',
    currentTemplateStepId: '',
    templateNodeId, //当前整软定需求id
    trackTabs: [],
    isPublicSea: false, // 是否公海详情
  })

  const [trackDetail, setTrackDetail] = useSetState<any>({})

  // useEffect(() => {
  //   if (saleClueId) {
  //     getTrackInfo()
  //   }
  // }, [detailState.isReloadTrack])

  useEffect(() => {
    setDetailState({isPublicSea: props.isPublicSea})
  }, [props.isPublicSea]);

  useEffect(() => {
    if (saleClueId || detailState.templateNodeId) getTrackInfo()
  }, [saleClueId, detailState.templateNodeId, detailState.isReloadTrack])

  useEffect(() => {
    if (id && id != 'undefined') getInfo()
  }, [id, detailState.isReload]);

  useEffect(() => {
    if (detailState.id) getTrackTabInfo(detailState.id, detailState.templateNodeId)
  }, [detailState.id, detailState.isReloadTrackTab]);

  const getTrackInfo = () => {
    trackPlanBaseInfo(saleClueId || detailState.templateNodeId).then(res => {
      // console.log('trackDetail:', res)
      setDetailState({ trackDetail: res })
      setTrackDetail(res)
    })
  }

  const getInfo = () => {
    setDetailState({loading: true})
    getClueDetail(id).then(res => {
      setDetailState({ ...res, loading: false })
    })
  }

  const getTrackTabInfo = (id, templateNodeId: any) => {
    getTrackDetailByClueId(id).then(res => {
      setDetailState({trackTabs: res})
      let current = res[0]
      if (templateNodeId) {
        current = res.find(item => item.id === templateNodeId)
      }
      setDetailState({templateStepId: current?.salesTemplateId, currentTemplateStepId: current?.currentNodeId, templateNodeId: current?.id})
    })
  }

  const updateDetail = state => {
    setDetailState({ ...state })
  }

  return (
    <>
      <ClueDetailContext.Provider value={{ detailState, updateDetail, trackDetail, viewPhoneKey, editPhoneKey, editKey, isWorkBench }}>
        <SBack level={2} title={'详情'} titleStyle={{ marginBottom: 10 }} gutter={0} goPath={() => {
          const params = new URLSearchParams(location.search);
          const returnUrl = params.get('returnUrl');
          if (returnUrl) {
            window.open(decodeURIComponent(returnUrl), '_self');
          } else {
            console.log('goBack')
            navigate('/saleOp/salesWorkbench/list')
          }
        }}>
          <Spin spinning={detailState.loading}>
            <div className={classNames([styles.flexBetweenStart, styles.detailBox])}>
              <div className={styles.colBox}>
                <UserInfo/>
              </div>
              <div className={styles.colBox}>
                {(!saleClueId && ['DESIGN', 'TO_SHOP'].includes(detailState.status)) && <BizTypeInfo />}
                <STitle style={{ marginBottom: 20 }} title="销售计划节点" />
                <NodeSteps className={styles.mb20} trackDetail={trackDetail} isReload={detailState.isReloadNode}/>
                <STitle style={{ marginBottom: 20 }} title="节点活动" />
                <TaskNode />
              </div>
              <div className={styles.colBox}>
                <STitle style={{ marginBottom: 20 }} title={'跟进记录'} />
                <FollowUpRecords />
              </div>
            </div>
          </Spin>
        </SBack>
      </ClueDetailContext.Provider>
    </>
  )
}

export default ClueDetailNewPage
